import React, { Component } from 'react';

class PrivacyPolicyPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page privacy-page">
        <div className="tos-hero">
          <div className="container">
            <p className="tos-eyebrow">Jason's Wine &amp; Spirits</p>
            <h1 className="page-title">Website and App Privacy Policy</h1>
            <p className="tos-updated"><strong>Effective Date:</strong> [Insert Date]</p>
          </div>
        </div>

        <div className="container">
          <div className="terms-card">
            <div className="terms-section">
              <h3>1. INTRODUCTION</h3>
              <p>
                Jason's Wine and Spirits ("Jason's," "Company," "we," "us," or "our") is committed to protecting your
                privacy. This Website and App Privacy Policy ("Privacy Policy") explains how we collect, use, disclose,
                and protect information about you when you:
              </p>
              <ul>
                <li>Visit our website at http://jasonsliquor.com (the "Site");</li>
                <li>Use our mobile application (the "App"); or</li>
                <li>Otherwise interact with us online or offline in connection with our products and services (together with the Site and the App, the "Services").</li>
              </ul>
              <p>
                This Privacy Policy applies only to the Services that we control and not to third-party websites, apps,
                or services that may be linked from the Site or the App. Those third parties may have their own privacy
                policies, which we encourage you to review. By using the Services, you agree to the practices described
                in this Privacy Policy and our Terms of Use. If you do not agree, please do not use the Services.
              </p>
            </div>

            <div className="terms-section">
              <h3>2. INFORMATION WE COLLECT</h3>
              <p>We collect information in three main ways: (1) information you provide to us, (2) information we collect automatically, and (3) information we receive from third parties.</p>

              <h4>2.1 Information You Provide to Us</h4>
              <p>We may collect information that you provide directly to us, including:</p>
              <ul>
                <li>Contact Information: Name, email address, mailing address, phone number.</li>
                <li>Account &amp; Profile Information: Username and password, communication preferences, order history and saved preferences.</li>
                <li>Order &amp; Transaction Information: Products you order, delivery instructions, date and time of purchases.</li>
                <li>Payment Information: Limited payment card details or tokenized information (e.g., last four digits of card, card type), billing address. We use third-party payment processors (such as Stripe, Apple Pay, and Google Pay) to process payments. We do not store your full payment card number on our own systems.</li>
                <li>Demographic &amp; Age-Related Information: ZIP code or address, date of birth or age, any other demographic information you choose to provide.</li>
                <li>Communications &amp; Support: Emails and messages you send to us; information you submit through forms, surveys, promotions, reviews, chat, or support requests.</li>
                <li>User Content: Reviews, ratings, comments, and any content you post or submit through the Services.</li>
              </ul>

              <h4>2.2 Information We Collect Automatically</h4>
              <p>When you access or use the Site or the App, we may automatically collect certain information ("Usage Information"), such as:</p>
              <ul>
                <li>Device &amp; Technical Information: IP address, device identifiers, browser type and version, operating system and platform, mobile network information.</li>
                <li>Usage &amp; Activity Information: Pages or screens you view, links you click, time and date of visits, App usage, features used, and actions taken.</li>
                <li>Location Information: Approximate location based on IP address; precise location if you grant the App permission (e.g., to show nearby store, enable delivery, or estimate delivery time).</li>
                <li>Cookies &amp; Similar Technologies: We and our service providers use cookies and similar technologies to recognize your browser or device, remember preferences, customize experiences, analyze traffic, and support marketing/advertising. You can control certain cookies through your browser settings, but disabling cookies may affect some features.</li>
              </ul>

              <h4>2.3 Information from Third Parties</h4>
              <p>We may receive information about you from third parties, such as:</p>
              <ul>
                <li>Payment Processors (e.g., Stripe, Apple Pay, Google Pay), who may provide information related to your payment and transaction status;</li>
                <li>Delivery and Shipping Partners, who may provide delivery status and confirmation;</li>
                <li>Analytics and Advertising Partners, who may provide information about your interactions with our Site, App, or ads;</li>
                <li>Social Media Platforms, if you interact with us through social features or log in via social accounts (where available).</li>
              </ul>
              <p>We treat any such information in accordance with this Privacy Policy.</p>
            </div>

            <div className="terms-section">
              <h3>3. HOW WE USE YOUR INFORMATION</h3>
              <p>We use the information we collect for various business and commercial purposes, including to:</p>
              <ul>
                <li><strong>Provide and Operate the Services:</strong> Process and fulfill orders; provide delivery, shipping, and pickup services; create and manage your account.</li>
                <li><strong>Verify Age and Identity:</strong> Confirm you are at least 21; help prevent fraud, unlawful purchases, and sales to minors.</li>
                <li><strong>Communicate with You:</strong> Send order confirmations, receipts, and updates; respond to questions and support requests; send service, security, or account-related notices.</li>
                <li><strong>Personalize Your Experience:</strong> Tailor content, offers, and recommendations; remember your preferences and settings.</li>
                <li><strong>Marketing and Promotions (where permitted by law):</strong> Send promotional emails and offers; provide targeted advertising; run sweepstakes, contests, or other promotions.</li>
                <li><strong>Analytics, Research, and Service Improvement:</strong> Analyze usage trends and measure performance; improve features, user experience, and product offerings.</li>
                <li><strong>Security and Fraud Prevention:</strong> Detect, investigate, and prevent fraudulent transactions and other illegal activities; protect the safety, rights, and property of Jason's, our users, and others.</li>
                <li><strong>Legal and Compliance Purposes:</strong> Comply with applicable laws; respond to lawful requests; enforce our Terms of Use and other policies.</li>
              </ul>
              <p>We may aggregate or de-identify information so that it can no longer reasonably be used to identify you, and we may use and share such information for any lawful purpose.</p>
            </div>

            <div className="terms-section">
              <h3>4. HOW WE SHARE INFORMATION</h3>
              <h4>4.1 Service Providers and Business Partners</h4>
              <p>We share information with third-party companies that provide services to us or on our behalf, such as payment processing, hosting, analytics, delivery and shipping, email/SMS delivery, security and fraud prevention, customer support, and marketing support.</p>

              <h4>4.2 Advertising and Marketing Partners</h4>
              <p>
                Where permitted by law and consistent with your choices, we may share certain information with advertising and marketing partners to help deliver relevant ads and measure effectiveness. Some sharing may be considered a "sale" or "sharing" of personal information under applicable privacy laws. We provide ways to opt out where required.
              </p>

              <h4>4.3 In Connection with a Business Transfer</h4>
              <p>We may share or transfer your information if we are involved in or considering a merger, acquisition, financing, reorganization, bankruptcy, sale of assets, or transition of services to another provider.</p>

              <h4>4.4 For Legal, Security, and Safety Reasons</h4>
              <p>We may disclose information if we believe in good faith that such disclosure is reasonably necessary to comply with law, protect rights and safety, prevent fraud or technical issues, or enforce our policies.</p>

              <h4>4.5 With Your Consent</h4>
              <p>We may share information with third parties when you direct us or consent to such sharing, such as co-branded promotions or referrals.</p>
            </div>

            <div className="terms-section">
              <h3>5. THIRD-PARTY PAYMENT PROCESSORS</h3>
              <p>
                When you make a purchase through the Services, payments are processed by third-party payment processors
                such as Stripe, Apple Pay, and Google Pay. These companies collect and use your payment information in
                accordance with their own privacy policies and may collect additional information to process payment.
                We do not control how these third parties use your information and are not responsible for their privacy practices.
              </p>
              <p>We encourage you to review their privacy policies:</p>
              <ul>
                <li>Stripe: https://stripe.com/privacy</li>
                <li>Apple Pay: https://www.apple.com/legal/privacy/</li>
                <li>Google Pay: https://payments.google.com</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>6. YOUR CHOICES AND CONTROLS</h3>
              <p>You have several choices regarding how we use your information.</p>
              <ul>
                <li><strong>Account Information:</strong> Review and update certain account information by logging in and adjusting profile and preferences.</li>
                <li><strong>Marketing Communications:</strong> Opt out by following unsubscribe instructions in emails or contacting order@jasonsliquor.com. You may still receive transactional messages.</li>
                <li><strong>SMS/Text Messages:</strong> Opt out of marketing texts by following the instructions in the message (e.g., replying "STOP"). Transactional texts may still be sent where permitted.</li>
                <li><strong>Cookies and Tracking Technologies:</strong> Manage cookies through browser settings. Some features may be affected if cookies are disabled. Our Services may not respond to DNT signals in a standardized way.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>7. ACCESS, CORRECTION, AND DELETION</h3>
              <p>
                Where required by law, you may have the right to request access, correction, or deletion of personal information, and to request information about how we have used and shared it. Submit requests by emailing order@jasonsliquor.com with subject "Privacy Request." We may need to verify your identity and will respond as required by law.
              </p>
            </div>

            <div className="terms-section">
              <h3>8. SECURITY OF YOUR INFORMATION</h3>
              <p>
                We use reasonable administrative, technical, and physical safeguards designed to protect your personal information from unauthorized access, use, or disclosure. However, no method is completely secure. You are responsible for keeping credentials confidential and notifying us promptly if you believe your account or password has been compromised.
              </p>
            </div>

            <div className="terms-section">
              <h3>9. CALIFORNIA PRIVACY RIGHTS</h3>
              <p>This section supplements the rest of this Privacy Policy and applies only to California residents.</p>
              <h4>9.1 Categories of Personal Information We Collect</h4>
              <p>In the preceding 12 months, we may have collected categories such as identifiers, customer records, commercial information, internet or electronic network activity, geolocation data, demographic information, and inferences drawn from the above.</p>

              <h4>9.2 Business or Commercial Purposes for Use</h4>
              <p>We use these categories for the purposes described in Section 3, including providing services, personalization, marketing, improvement, security, and compliance.</p>

              <h4>9.3 Disclosures of Personal Information</h4>
              <p>We may disclose personal information to service providers, advertising/marketing partners, professional advisors, successor entities, and government authorities, some of which may be considered a "sale" or "sharing" under California law. We provide ways to limit or opt out where required.</p>

              <h4>9.4 Your California Privacy Rights</h4>
              <p>Subject to exceptions, California residents may have rights to know/access, delete, correct, opt out of sale/sharing, limit use of sensitive personal information (if applicable), and non-discrimination. To exercise rights, email order@jasonsliquor.com with the subject line "California Privacy Request" and/or use any available tools on the Site or App. We may need to verify identity; authorized agents may submit requests subject to verification.</p>

              <h4>9.5 "Shine the Light" Law</h4>
              <p>
                Under California's "Shine the Light" law, residents may request once per calendar year information about categories of personal information we shared with third parties for their direct marketing purposes (if any) and the names and addresses of such third parties. Email order@jasonsliquor.com with "Request for California Privacy Information" in the subject line and body of your message.
              </p>
            </div>

            <div className="terms-section">
              <h3>10. CHILDREN AND MINORS</h3>
              <p>Our Services are not directed to anyone under the age of 21, and we do not knowingly collect personal information from individuals under 21. If we learn that we have collected personal information from someone under 21, we will take reasonable steps to delete it. If you believe we might have information from or about a person under 21, please contact order@jasonsliquor.com.</p>
            </div>

            <div className="terms-section">
              <h3>11. INTERNATIONAL USERS</h3>
              <p>
                The Services are operated from the United States and intended primarily for users located in the United States. If you access the Services from outside the U.S., you understand that your information may be transferred to, stored, and processed in the U.S. or other countries, and that data protection laws may differ. By using the Services, you consent to these transfers.
              </p>
            </div>

            <div className="terms-section">
              <h3>12. CHANGES TO THIS PRIVACY POLICY</h3>
              <p>
                We may update this Privacy Policy from time to time. When we do, we will post the updated Privacy Policy on the Site and/or in the App and update the "Effective Date" at the top. Any changes will be effective as of the date we post the revised Privacy Policy, unless otherwise stated. Your continued use of the Services after the Effective Date means you accept the updated Privacy Policy.
              </p>
            </div>

            <div className="terms-section">
              <h3>13. CONTACT US</h3>
              <p>If you have any questions, comments, or requests regarding this Privacy Policy or our privacy practices, you may contact us at:</p>
              <p className="address-block">
                Jason's Wine and Spirits<br />
                828 S. Main Street<br />
                Los Angeles, CA 90014<br />
                Email: order@jasonsliquor.com<br />
                Phone: (213) 485-9463
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicyPage;



// WEBPACK FOOTER //
// ./src/containers/privacy-policy/PrivacyPolicyPage.js